import React, { useState } from 'react';
import { FinanceProvider } from './contexts/FinanceContext';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import OnboardingModal from './components/OnboardingModal';
import Dashboard from './components/Dashboard';
import TransactionList from './components/TransactionList';
import PeopleManager from './components/PeopleManager';
import CategoryManager from './components/CategoryManager';
import RecurringManager from './components/RecurringManager';
import Settings from './components/Settings';

function AppContent() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const tabTitles = {
    dashboard: 'Dashboard',
    transactions: 'Transactions',
    people: 'People & Money',
    categories: 'Categories & Tags',
    recurring: 'Recurring',
    settings: 'Settings',
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard onNavigate={setActiveTab} />;
      case 'transactions':
        return <TransactionList />;
      case 'people':
        return <PeopleManager />;
      case 'categories':
        return <CategoryManager />;
      case 'recurring':
        return <RecurringManager />;
      case 'settings':
        return <Settings />;
      default:
        return <Dashboard onNavigate={setActiveTab} />;
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex">
      {/* Onboarding Modal */}
      <OnboardingModal />
      
      {/* Sidebar */}
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        isOpen={sidebarOpen}
        setIsOpen={setSidebarOpen}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-screen overflow-hidden">
        <Header 
          title={tabTitles[activeTab]} 
          onMenuClick={() => setSidebarOpen(true)}
        />
        
        <main className="flex-1 overflow-y-auto">
          {renderContent()}
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <FinanceProvider>
      <AppContent />
    </FinanceProvider>
  );
}

export default App;
